import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { themeSpace } from 'styles/themeUtils';

const SectionParagraph = styled(Typography)`
  margin-bottom: ${themeSpace(1.5)};

  &:last-child {
    margin-bottom: 0px;
  }
`;

SectionParagraph.displayName = 'SectionParagraph';

export default SectionParagraph;
